import React from 'react';

interface EmptyStateProps {
  simFlag: boolean;
  hasSimulationTasks: boolean;
  entityType: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ simFlag, hasSimulationTasks, entityType = '' }) => {
  if (simFlag) {
    return (
      <div className="dark:text-white text-gray-800 flex justify-center items-center h-full">
        {`You currently have no ${entityType.toLowerCase()} in simulation mode.`}
      </div>
    );
  }

  return (
    <div className="dark:text-white text-gray-800 flex justify-center items-center h-full">
      {hasSimulationTasks ? (
        <div className="text-center">
          <p>{`You currently have no ${entityType.toLowerCase()} in live mode.`}</p>
          <p className="font-semibold text-blue-600 dark:text-blue-400">
            {`${entityType} are available in simulation mode. Please toggle to simulation mode to view them.`}
          </p>
        </div>
      ) : (
        <div className="text-center">
          <p>{`You currently have no ${entityType.toLowerCase()} in live mode.`}</p>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
export type { EmptyStateProps }; 